define('plugin/location/view/LocationStepView',['require','lib/view/CompositeView','plugin/location/view/LocationItemView','plugin/location/view/LocationEmptyView'],function (require) {

	var CompositeView = require('lib/view/CompositeView');
	var LocationItemView = require('plugin/location/view/LocationItemView');
	var LocationEmptyView = require('plugin/location/view/LocationEmptyView');

	/**
	 * Location composite view (locations container)
	 * 
	 * @class LocationStepView
	 */
	return CompositeView.extend({
	
	    template: '#location_step',
	    childView: LocationItemView,
	    childViewContainer: '#sb_location_step_container',
        
        emptyView: LocationEmptyView,
        isEmpty: function (collection) {
            return collection._once_synced ? collection.isEmpty() : false;
        },

		_pageId: 'booking_location'
	    
	});
	
});
